import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      name:'Home',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(['@/pages/home'],resolve),
    },
    {
      path:'/home',
      name:'Home',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(['@/pages/home'],resolve),
    },
    {
      path:'/team',
      name:'Team',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/team"],resolve),
    },
    {
      path:'/answer',
      name:"Answer",
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/answer"],resolve),
    },
    {
      path:'/myTeam',
      name:"MyTeam",
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/myTeam"],resolve),
    },
    {
      path:'/stand',
      name:"Stand",
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/stand"],resolve),
    },
    {
      path:'/helplist',
      name:'HelpList',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/helplist"],resolve),
    },
    {
      path:'/invitelist',
      name:'Invitelist',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/invitelist"],resolve),
    },
    {
      path:'/assistance',
      name:'Assistance',
      meta:{
        title:'新航道519雅思节 9分达人争霸赛',
      },
      component:resolve => require(["@/pages/assistance"],resolve),
    },
    {
      path:'/combatGains',
      name:'CombatGains',
      meta:{
        title:'我在9分达人争霸赛中技压群雄，特等奖是我的了！',
        content:'我在9分达人争霸赛中技压群雄，特等奖是我的了！'
      },
      component:resolve => require(["@/pages/combatGains"],resolve),
    },
    {
      path:'/invitePeople',
      name:'InvitePeople',
      meta:{
        title:'邀请你加入最强达人战队，与我一起争当九分达人！',
        content:'邀请你加入最强达人战队，与我一起争当九分达人！'
      },
      component:resolve => require(["@/pages/invitePeople"],resolve),
    },
    {
      path:'/inviteFriend',
      name:'InviteFriend',
      meta:{
        title:'我在参加9分达人争霸赛 请你动动小手为我助力~',
        content:'我在参加9分达人争霸赛 请你动动小手为我助力~'
      },
      component:resolve => require(["@/pages/inviteFriend"],resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js